import { useEffect } from 'react'
import { isPrivateFileLink, saveFileFromUrl } from '../utils'
import { useGlobalStore } from '../services/store/store'

const useTrackFileLinks = () => {
	const userToken = useGlobalStore((state) => state.userToken)
	useEffect(() => {
		const handleFileLinkClick = async (event) => {
			const target = event.target.closest('a')
			if (!target) return

			const href = target.getAttribute('href')
			if (!href) return

			if (isPrivateFileLink(href)) {
				event.preventDefault()
				await saveFileFromUrl(href, userToken)
			}
		}

		document.addEventListener('click', handleFileLinkClick)

		return () => {
			document.removeEventListener('click', handleFileLinkClick)
		}
	}, [userToken])
}

export default useTrackFileLinks
